import { useState } from 'react';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppText } from 'shared/UI/UIKit/Text';
import { useAppDispatch } from 'shared/services/redux/hooks/use-dispatch';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';
import { removeMunicipalityAction } from 'features/municipalities/redux/actions';
import type { RemoveMunicipalityModalProps } from './types';
import { MunicipalityModalFooter } from '../ModalFooter';
import styles from './Remove.module.scss';

export const RemoveMunicipalityModal = (props: RemoveMunicipalityModalProps) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { selectedMunicipality } = useAppSelector((state) => state.municipalitiesState);

  const confirm = () => {
    if (!selectedMunicipality) return;

    setLoading(true);
    dispatch(removeMunicipalityAction(selectedMunicipality.id))
      .unwrap()
      .then(() => {
        props.onItemRemove();
        props.hide();
      })
      .finally(() => setLoading(false));
  };

  const footer = (
    <MunicipalityModalFooter onSubmit={confirm} hideModal={props.hide} title="Удалить" />
  );

  const content = (
    <AppFlex unit="8" className={styles.content}>
      <AppText size={16} type="secondary">
        Подтвердите удаление муниципалитета
      </AppText>
      <AppText size={18}>{selectedMunicipality?.name || ''}</AppText>
    </AppFlex>
  );

  return (
    <AppModal
      visible={props.visible}
      onCancel={props.hide}
      size="auto"
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Удаление муниципалитета"
      maskClosable={false}
    />
  );
};
